var React = require('react');

function So (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M18.6941 16.1147H20.9251V25H0.846191V16.1147H3.07718V22.7787H18.6941V16.1147Z","fill":"white","key":0}),React.createElement("path",{"d":"M5.51104 15.4483L16.4632 17.7504L16.9297 15.5695L5.97752 13.2674L5.51104 15.4483ZM6.95105 10.2383L17.0919 14.9435L18.0452 12.9241L7.90429 8.2189L6.95105 10.2383ZM9.77021 5.2706L18.3697 12.399L19.8097 10.6826L11.2102 3.55412L9.77021 5.2706ZM15.3274 0L13.5223 1.33279L20.195 10.2787L22.0001 8.94588L15.3274 0ZM5.30823 20.5574H16.4632V18.336H5.30823V20.5574Z","fill":"white","key":1})]));
}

So.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = So;

So.default = So;
